<ng-container *transloco="let t; read: 'fiscal-year'">
  <ng-container *ngIf="vm$ | async as vm">
    <h2 class="mbm">{{t('title')}}</h2>

    <kendo-grid
      [data]="vm.fiscalYears"
      (edit)="editHandler($event)"
      (cancel)="cancelHandler($event)"
      (save)="saveHandler($event)"
      (remove)="removeHandler($event)"
      (add)="addHandler($event)"
      [style.maxHeight.px]="600"
    >
      <ng-template kendoGridToolbarTemplate>
        <button kendoGridAddCommand>{{t('add')}}</button>
      </ng-template>
      <kendo-grid-column field="startDate" [title]="t('startDate')">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.startDate | dateCustom:'month-long'}}
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <kendo-formfield>
            <kendo-datepicker
              [formControl]="formGroup.get('startDate')"
              bottomView="year"
              topView="decade"
              format="MMM yyyy"
            ></kendo-datepicker>
            <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
          </kendo-formfield>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="endDate" [title]="t('endDate')">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.endDate | dateCustom:'month-long'}}
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <kendo-formfield>
            <kendo-datepicker
              [formControl]="formGroup.get('endDate')"
              bottomView="year"
              topView="decade"
              format="MMMM yyyy"
            ></kendo-datepicker>
            <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
          </kendo-formfield>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [title]="t('locked')">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span *ngIf="dataItem.lockedOn">
            {{ dataItem.lockedOn | date:'dd.MM.yyyy HH:mm'}} <br>
            {{ dataItem.lockedById | employee | async}} 
          </span>
        </ng-template>
      </kendo-grid-column>
      
    
      <kendo-grid-command-column>
        <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem>
          <button 
            kendoGridEditCommand 
            themeColor="primary"
            *ngIf="!dataItem.lockedOn"
            >
            <kendo-svg-icon [title]="t('edit')" [icon]="icons.edit"></kendo-svg-icon>
          </button>

          <button kendoGridRemoveCommand  *ngIf="!dataItem.lockedOn">
            <kendo-svg-icon [title]="t('delete')" [icon]="icons.delete"></kendo-svg-icon>
          </button>

          <button kendoGridSaveCommand [disabled]="formGroup?.invalid"  *ngIf="!dataItem.lockedOn">
            <kendo-svg-icon [title]="isNew ? t('add') : t('save')" [icon]="icons.save"></kendo-svg-icon>
          </button>

          <button kendoGridCancelCommand  *ngIf="!dataItem.lockedOn">
            <kendo-svg-icon [title]="isNew ? t('discard') : t('cancel')" [icon]="icons.cancel"></kendo-svg-icon>
          </button>

          <button 
            kendoButton
            *ngIf="!dataItem.lockedOn"
            (click)="lockItemSub$.next(dataItem.id)"
            loadingIndication="/FiscalYear/LockFiscalYear"
            >
              <kendo-svg-icon [title]="t('lock')" [icon]="icons.lock"></kendo-svg-icon>
          </button>

          <button 
            kendoButton
            *ngIf="dataItem.lockedOn"
            (click)="unlockItemSub$.next(dataItem.id)"
            loadingIndication="/FiscalYear/UnlockFiscalYear"
            >
              <kendo-svg-icon [title]="t('unlock')" [icon]="icons.unlock"></kendo-svg-icon>
          </button>
        </ng-template>
      </kendo-grid-command-column>

      <ng-template kendoGridNoRecordsTemplate>
        {{t('noResults')}}
      </ng-template>
    </kendo-grid>

    <app-delete-confirm-dialog
      [(opened)]="deletionDialogOpened"
      [message]="t('deletionMessage')"
      (confirmed)="deleteConfirmed()"
    ></app-delete-confirm-dialog>

  </ng-container>
</ng-container>
